import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { H2 } from 'foundations-components/transitional/components/H2';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { PageSection } from 'pricing-pages-ui-components/semantic/PageSection';
import PhoneSupport from './PhoneSupport';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PhoneSupportMiddle = ({
  phoneSourceId,
  screen,
  apiName
}) => {
  return /*#__PURE__*/_jsx(PageSection, {
    children: /*#__PURE__*/_jsxs(Flex, {
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
      children: [/*#__PURE__*/_jsx(H2, {
        typography: "heading-300",
        "data-selenium-id": "phone-support-middle-header",
        textAlign: "center",
        marginBlock: "200",
        marginBlockEnd: "300",
        display: "block",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.phone-supportV2.needHelp"
        })
      }), /*#__PURE__*/_jsx(View, {
        borderWidth: "100",
        borderStyle: "solid",
        borderColor: "border-core-default",
        borderRadius: "full",
        paddingInline: "800",
        children: /*#__PURE__*/_jsx(PhoneSupport, {
          phoneSourceId: phoneSourceId,
          screen: screen,
          apiName: apiName
        })
      })]
    })
  });
};
export default PhoneSupportMiddle;